import addCLickEvents from './add-click-events';

export default function(rootElement) {
  const modalFrame = `
    <div class="sdc-site-modal__backing" data-role="modal-backing">
      <div class="sdc-site-modal__message" data-role="modal-message">
        <button class="sdc-site-modal__close-button" data-role="modal-close"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><path d="M25.775 24.857a.776.776 0 0 0-.252-.537l-6.534-6.534-.354-.354.354-.354 7.031-7.031a7.798 7.798 0 0 0-.648-.728c-.384-.384-.614-.441-.716-.441a.777.777 0 0 0-.547.252l-6.534 6.534-.354.354-.354-.354-7.031-7.03a7.602 7.602 0 0 0-.728.648c-.287.287-.448.552-.441.726a.774.774 0 0 0 .252.537l6.534 6.534.354.354-.354.354-7.031 7.031a7.602 7.602 0 0 0 .648.728c.384.384.613.442.716.442a.777.777 0 0 0 .547-.252l6.535-6.535.354-.354.354.354 7.031 7.031a8.203 8.203 0 0 0 .728-.648c.286-.287.446-.552.44-.727z"/></svg> Close</button>
        <div class="sdc-site-modal__message-content" data-role="modal-content-area">
        </div>
      </div>
    </div>
  `;

  rootElement.insertAdjacentHTML('beforeend', modalFrame);

  rootElement.setAttribute('aria-hidden', 'true');
  rootElement.setAttribute('fading', '');

  addCLickEvents(rootElement);
}
